import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "router/const";

type PrivateRouteProps = {
  isAuthenticated: boolean;
};

export const GuestRoute = ({ isAuthenticated }: PrivateRouteProps) => {
  if (isAuthenticated) return <Navigate to={ROUTES.ROOT.PATH} replace />;

  return (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  );
};
